"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccountDetailsCardCms = void 0;
var BankAccountDetailsCardCms = /** @class */ (function () {
    function BankAccountDetailsCardCms() {
        this.bankNameLabel = 'Name on bank account';
        this.bankNameMinCharactersErrTxt = 'Minimum 2 characters';
        this.routingTransitLabel = 'Routing transit number';
        this.routingTransitMinLengthErrTxt = 'Minimum 9 characters';
        this.bankAccountLabel = 'Bank account number';
        this.bankAccountMinLengthErrTxt = 'Minimum 5 characters';
        this.reEnterBankAccountLabel = 'Re-enter bank account number';
        this.bankAccountNotMatchErrTxt = 'Must match Bank Account Number Value';
        this.routingTransitToolTipText = 'Routing transit number';
        this.routingTransitToolTipImage = '/idpassets/buy/images/bank_routing_number.png';
        this.bankAccountToolTipAltImage = '/idpassets/buy/images/bank_account.png';
        this.bankAccountToolTipText = 'Bank account number';
        this.routingTransitToolTipAltText = 'Your bank\'s routing number is the first 9' +
            ' digits located at the bottom left of your personal checks.';
        this.bankAccountToolTipAltText = 'Your account number is usually found at the bottom' +
            'of a personal check between the bank\'s 9-digit routing number and the check number.';
    }
    return BankAccountDetailsCardCms;
}());
exports.BankAccountDetailsCardCms = BankAccountDetailsCardCms;
//# sourceMappingURL=BankAccountDetailsCardCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/PaymentCard/BankAccountDetailsCard/BankAccountDetailsCardCms.cms.js
// module id = 2027
// module chunks = 8